import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=539c44ab&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=ts"
export * from "./Icons.vue?vue&type=script&lang=ts"
import style0 from "./Icons.vue?vue&type=style&index=0&id=539c44ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c44ab",
  null
  
)

export default component.exports